
const scrollToTopInternal = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
};

export const scrollToTop = () => {
  setTimeout(scrollToTopInternal, 100, false);
}


